/**
 * Rotating placeholder lines in the empty planning composer (homepage / embedded).
 * Not sent as messages. Full set is shown in rotation (~2.2s per line before advancing).
 */
export const PLANNING_INPUT_EXAMPLE_PROMPTS: readonly string[] = [
  'I want to build PE value creation plan for a packaging business in Illinois',
  'Help me improve my transformation roadmap.',
  'Build me an AI transformation roadmap for a pharmaceutical industry.',
  'Create post acquisition integration plan for IT',
  'Design a 100-day plan after acquiring a regional logistics company.',
  'Map a cost takeout and operating model reset for a North American bank.',
  'Turn our board strategy deck into an execution roadmap with milestones.',
  'Plan a cloud migration and application rationalization for a mid-market insurer.',
  'Help me sequence ERP rollout across three countries without stopping the business.',
  'Build a roadmap to double e-commerce revenue in 18 months for a specialty retailer.',
  'Create a sustainability and decarbonization roadmap for an industrial manufacturer.',
  'I need a transformation plan for a hospital system merging two clinical networks.',
  'Outline how we scale a SaaS product from $20M to $80M ARR with the same headcount.',
  'Draft a data and AI governance path before we deploy generative AI to employees.',
  'Help me align sales, marketing, and customer success on one growth initiative.',
  'Plan operational due diligence themes for a carve-out from a Fortune 500 parent.',
  'Build a roadmap to fix delivery reliability and NPS for a B2B services firm.',
  'Create a workforce and change plan for automating our finance close process.',
  'I want a roadmap for entering two new geographies with a partner-led GTM model.',
  'Help me prioritize twelve initiatives under one enterprise transformation program.',
  'Design a product-led growth experiment roadmap for our freemium analytics tool.',
  'Map security, privacy, and resilience upgrades before our IPO readiness window.',
  'Build a supply chain resilience plan after recent disruptions in key commodities.',
  'Create a roadmap to consolidate five brands onto one platform in 24 months.',
  'Help me structure a digital factory initiative for discrete manufacturing.',
  'I need a clear path from current KPI chaos to one executive scorecard.',
  'Plan transformation for a regulated utility adding grid-scale storage and EV load.',
  'Outline how we modernize legacy core systems without a big-bang cutover.',
  'Build a customer experience transformation tied to measurable revenue outcomes.',
  'Create a post-merger synergy capture roadmap for overlapping corporate functions.',
  'Help me turn a vague “AI everywhere” mandate into phased, funded initiatives.',
  'Design a roadmap to improve cash conversion cycle across procurement and AP.',
  'Map initiatives to become a net-zero logistics operator by 2030.',
  'I want to align PE operating partner priorities with management incentives.',
  'Build a transformation plan for a professional services firm adopting fixed-fee models.',
  'Help me sequence regulatory reporting changes across EU and UK entities.',
  'Create a roadmap to stand up a shared services center in waves.',
  'Plan how we industrialize innovation from three pilots to enterprise scale.',
  'Outline a resilience program: cyber, business continuity, and third-party risk.',
  'Help me refresh our three-year strategy into projects my COO can fund this year.',
];
